import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/_models';
import { AccountService } from 'src/app/_services/account.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mayne-user-box',
  templateUrl: './user-box.component.html',
  styleUrls: ['./user-box.component.scss']
})
export class UserBoxComponent {


  obs: Subscription[] = [];
  user: User | null = null;
  private avatarFailed = false;

  constructor(private router: Router, private accountService: AccountService) {

  }

  ngOnInit() {
    this.obs.push(this.accountService.getUser().subscribe(x => {
      this.user = x;
      this.avatarFailed = false;
    }));
  }
  
  ngOnDestroy() {
    this.obs.forEach(x => x.unsubscribe());
  }

  getAvatar(){
    if (!this.avatarFailed && this.user && this.user.profile_image != '' && this.user.profile_image){
      return this.user.profile_image;
    }
    return environment.avatar; 
  }

  onAvatarError() {
    if (!this.avatarFailed) {
      this.avatarFailed = true;
    }
  }

  logout() {
    this.accountService.logout();
  }
}
